import { normalizeType } from '@streamlain/field-types';
import { z } from 'zod';

export const AcceptedTypeSchema = z
  .string()
  .refine(t => normalizeType(t) === t, {
    message:
      'acceptedType must be canonical field-type (see @streamlain/field-types.normalizeType)',
  });

export const CapabilityRequirementSchema = z.object({
  field: z.string().min(1),
  acceptedTypes: z.array(AcceptedTypeSchema).min(1),
  required: z.boolean(),
  cardinality: z.enum(['one', 'many']).default('one'),
  defaultValue: z.unknown().optional(),
});

export const ComponentCapabilitySchema = z.object({
  role: z.string().min(1),
  description: z.string().optional(),
  required: z.boolean(),
  requirements: z.array(CapabilityRequirementSchema),
});

export type CapabilityRequirement = z.infer<typeof CapabilityRequirementSchema>;
export type ComponentCapability = z.infer<typeof ComponentCapabilitySchema>;

/**
 * Authoring-side type: cardinality + defaultValue are optional (defaults applied by Zod).
 * Used in ViewComponent.capabilities for ergonomic component declarations.
 * Registry.register() runs Zod parse → downstream consumers see the `infer` (output) type.
 */
export type ComponentCapabilityInput = z.input<
  typeof ComponentCapabilitySchema
>;
